import { StylesConfig } from 'react-select';

import { DefaultSelectStyle } from 'components/Shared/Forms/Select/styles';

export interface EditableSelectOption {
  value: string | number;
  label: string;
}

const schedulingSelectStyle = DefaultSelectStyle as StylesConfig<
  EditableSelectOption,
  true
>;

export const editableCellSelectStyle: StylesConfig<EditableSelectOption, true> =
  {
    ...schedulingSelectStyle,
    container: (base, state) => ({
      ...(schedulingSelectStyle.container?.(base, state) ?? base),
      height: 'auto',
      minHeight: '3rem',
      fontSize: '14px',
    }),
    control: (base, state) => ({
      ...(schedulingSelectStyle.control?.(base, state) ?? base),
      height: 'auto',
      minHeight: '3rem',
      overflow: 'hidden',
    }),
    valueContainer: (base, state) => ({
      ...(schedulingSelectStyle.valueContainer?.(base, state) ?? base),
      flexWrap: 'wrap',
      overflow: 'hidden',
    }),
    menuPortal: (base, state) => ({
      ...(schedulingSelectStyle.menuPortal?.(base, state) ?? base),
      zIndex: 100,
      fontSize: '14px',
    }),
    option: (base, state) => ({
      ...(schedulingSelectStyle.option?.(base, state) ?? base),
      fontSize: '14px',
    }),
  };
